<template>
  <div class="grid-container text-content">
    <div class="info-metadata">
      <b>Task No. {{paddingZero(item.taskId)}}</b>
      <p>{{item.name}}<br>{{structure.xp}}<small>XP</small></p>
    </div>
    <hr>
    <div v-html="item.content"/>
  </div>
</template>

<script>
  import TaskStructure from './TasklistPayload/TaskStructure'
  import TaskContent from './TasklistPayload/TaskContent'
  import {paddingZero} from '@/utilities/number'

  export default {
    name: 'lessonsText',
    data() {
      return {
        item: null,
        structure: null,
      }
    },
    created() {
      const id = parseInt(this.$route.params.id)
      this.item = TaskContent[id-1]
      this.structure = TaskStructure[id-1]
    },
    methods: {
      paddingZero
    }
  }
</script>

<style lang="scss" scoped>
  .text-content {
    padding: 1rem;
  }

  .info-metadata {
    display: flex;
    justify-content: space-between;
    align-items: center;

    b {
      font-weight: 900;
      font-size: 1.5rem;
      background: linear-gradient(to bottom right, #6f5da8, #1F2041);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    p {
      background: linear-gradient(to bottom right, #6f5da8, #1F2041);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-align: end;
    }
  }
</style>
